import { AhooksInfiniteScrollFrame } from "@/components/AhooksInfiniteScrollFrame";
import { DialogLocal } from "@/components/Dialog";
import { Icon } from "@/components/Icon";
import SubLayout from "@/components/SubLayout";
import { MsgItem } from "@/stores/user/useUserMsgStore";
import { useMount } from "ahooks";
import { PullToRefresh, SafeArea, Tabs, Toast } from "antd-mobile";
import classNames from "classnames";
import { useState } from "react";
import styles from "./index.module.scss";
import { useLogic } from "./logic";
import { useNavigate, useParams } from "react-router-dom";

const ListItem = ({
  item,
  onClick,
  onSelect,
  selectRows,
}: {
  selectRows: string[];
  item: MsgItem;
  onClick: (item: MsgItem) => void;
  onSelect: (item: MsgItem) => void;
}) => (
  <div
    className={classNames(
      styles.item,
      item.status === "Read" ? styles.read : styles.unRead
    )}
    key={item.contentId}
  >
    <div onClick={() => onSelect(item)}>
      <Icon
        name={
          selectRows.includes(`${item.contentId}`) ? "checked" : "unchecked"
        }
        size="16px"
      />
    </div>
    <div className={styles.text} onClick={() => onClick(item)}>
      <div className={styles.title}>{item.title}</div>
      <div className={styles.date}>{item.createTime}</div>
    </div>
    <div>
      <Icon name={"operate_arrow_right"} size="16px" />
    </div>
  </div>
);

const AnnouncementItem = ({
  item,
  onClick,
}: {
  item: MsgItem;
  onClick: (item: MsgItem) => void;
}) => {
  return (
    <div
      className={classNames(styles.item, styles.unRead,styles.noticeBox)}
      key={item.contentId}
    >
      <div className={styles.text} onClick={() => onClick(item)}>
        <div className={styles.title}>
          <Icon name={"global_notice"} size={"0.16rem"} />
          <span className={styles.titleTxt}>{item.title}</span>
        </div>
        <div className={styles.date}>{item.createTime}</div>
      </div>
      {/* <div>
        <Icon name={"operate_arrow_right"} size="0.16rem" />
      </div> */}
      <div className={styles.textCont}>
        <span className={styles.textConts}>{item.content}</span>
        <Icon name={"operate_arrow_right"} size="0.16rem" />
      </div>
    </div>
  );
};

export function PageMessagesPage() {
  const logic = useLogic();
  const [selectRows, setSelectRows] = useState<MsgItem[]>([]);
  const navigate = useNavigate();
  const { tab: paramsTab } = useParams();
  const [tab, setTab] = useState(paramsTab);

  useMount(() => {
    logic.messagesList.reload();
    logic.announcementsList.reload();
  });

  const onItemClick = (item: MsgItem) => {
    logic.fetchClickRead(item);
  };

  const onItemSelect = (item: MsgItem) => {
    const index = selectRows.findIndex(
      (row) => `${row.contentId}` === `${item.contentId}`
    );
    if (index > -1) {
      selectRows.splice(index, 1);
    } else {
      selectRows.push({ ...item });
    }
    setSelectRows([...selectRows]);
  };
  const onActionClick = () => {
    DialogLocal({
      content: selectRows.length
        ? "确认删除已选中的信息？"
        : "确认全部置为已读？",
      confirmText: "确认",
      cancelText: "取消",
      onConfirm: () => {
        if (selectRows.length) {
          const ids = selectRows.map((item) => `${item.contentId}`);
          if (ids.length) {
            logic.fetchDeleteMessage(ids);
          } else {
            Toast.show("没有选中消息");
          }
        } else {
          logic.fetchAllRead();
        }
      },
    });
  };

  const messagesList = (
    <section className={styles.content} ref={logic.messagesListRef}>
      <PullToRefresh onRefresh={() => logic.messagesList.reloadAsync()}>
        <AhooksInfiniteScrollFrame {...logic.messagesList}>
          {logic.messagesList.data?.list.map((msg) => {
            return (
              <ListItem
                item={msg}
                onClick={onItemClick}
                key={msg.contentId}
                selectRows={selectRows.map((item) => `${item.contentId}`)}
                onSelect={onItemSelect}
              />
            );
          })}
        </AhooksInfiniteScrollFrame>
      </PullToRefresh>
      <div className={styles.whitespace}></div>
      <SafeArea position="bottom" />
    </section>
  );

  const announcementsList = (
    <section className={styles.content} ref={logic.announcementsListRef}>
      <PullToRefresh onRefresh={() => logic.announcementsList.reloadAsync()}>
        <AhooksInfiniteScrollFrame {...logic.announcementsList}>
          {logic.announcementsList.data?.list.map((msg) => (
            <AnnouncementItem item={msg} onClick={logic.toDetail} />
          ))}
        </AhooksInfiniteScrollFrame>
      </PullToRefresh>
      <div className={styles.whitespace}></div>
      <SafeArea position="bottom" />
    </section>
  );

  return (
    <SubLayout
      title={"消息中心"}
      header={{
        extra: tab === "msg" && (
          <div onClick={onActionClick}>
            <Icon
              name={selectRows.length ? "trash" : "clean"}
              size={"24px"}
            />
          </div>
        ),
      }}
    >
      <div className={styles.page}>
        <section className={styles.tabs}>
          <Tabs
            activeKey={tab}
            onChange={(key) => {
              navigate(`/messages/${key}`, { replace: true });
              setTab(key);
            }}
          >
            <Tabs.Tab key={"msg"} title="通知" />
            <Tabs.Tab key={"notice"} title="公告" />
          </Tabs>
        </section>

        {tab === "msg" ? messagesList : announcementsList}
      </div>
    </SubLayout>
  );
}
